import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import styles from '../Styles';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import SearchIcon from '@material-ui/icons/Search';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Autocomplete from '@material-ui/lab/Autocomplete';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
//import { pdf } from '@react-pdf/renderer';
//import SalesRepPDF from '../AutoShip/pdfs/salesSheet';
import Tooltip from '@material-ui/core/Tooltip';
import { saveAs } from 'file-saver';
import * as ROLES from '../../constants/roles';
import HomeIcon from '@material-ui/icons/Home';
import firebase from 'firebase/app';

//Actions
import { loadAutoShipCompany, exitAutoShipApp, clearAutoShipApp, clearAutoShipCompany } from '../../redux/actions/autoShipActions';
//import InputBase from '@material-ui/core/InputBase';

const INITIAL_STATE = {
  //loading: false,
  searchCompany: '',
};

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...INITIAL_STATE,
    };
  }

  componentDidMount() {
    this.setState({ loading: true });
  }

  searchForClinic = (event) => {
    event.preventDefault();
    //console.log('we will search for a clinic', this.state.searchCompany);

    this.props.loadAutoShipCompany({ clinicID: this.state.searchCompany, userID: this.props.auth.uid });
  };

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onCompanyUserChange = (comp) => {
    if (comp) {
      this.setState({
        searchCompany: comp.id,
      });
    }
  };

  createSalesSheetPdf = async ({ fileName, autoShipCompany }) => {
    const makePdf = firebase.functions().httpsCallable('createClinicSalesSheets');

    console.log('This is my autoship company ----> ', autoShipCompany);

    let pdfData = autoShipCompany.data;
    pdfData.id = autoShipCompany.id;
    pdfData.tier = autoShipCompany.naturalTier.tierName;

    makePdf({ data: pdfData })
      .then(async (result) => {
        // Read result of the Cloud Function.
        //var sanitizedMessage = result.data.text;
        console.log('these are my results ----> ', result.data.fileName);

        if (result.data) {
          if (result.data.fileName) {
            let downloadURL = await firebase.storage().ref().child(result.data.fileName).getDownloadURL();

            console.log('we have a url', downloadURL);
            fetch(downloadURL)
              .then((res) => res.blob())
              .then((blob) => {
                saveAs(blob, fileName);
              });
          }
        }
      })
      .catch((error) => {
        // Getting the Error details.
        //var code = error.code;
        const message = error.message;
        //var details = error.details;
        console.log('this is my error message ---> ', message);
        // ...
      });
    //const blob = await pdf(<SalesRepPDF clinic={autoShipCompany.data} salesRep={autoShipCompany.data.salesRep} tiers={autoShipCompany.pureTier.tierName !== autoShipCompany.naturalTier.tierName ? autoShipCompany.naturalTier : autoShipCompany.pureTier} />).toBlob();
    //saveAs(blob, fileName);

    await firebase
      .firestore()
      .collection('salesSheetPdf')
      .add({
        clinic: autoShipCompany.data.name,
        salesRep: autoShipCompany.data.salesRep,
        user: this.props.auth.uid,
        name: this.props.profile.fullName,
        tier: autoShipCompany.pureTier.tierName !== autoShipCompany.naturalTier.tierName ? autoShipCompany.naturalTier : autoShipCompany.pureTier,
        pdfCreated: firebase.firestore.FieldValue.serverTimestamp(),
      });
  };

  goHome = () => {
    this.props.exitAutoShipApp();
    this.props.clearAutoShipApp();
    this.props.clearAutoShipCompany();
  };

  render() {
    const { classes, t, companies, autoShipCompany } = this.props;
    //const { searchCompany } = this.state;
    const clinicNameFileSafe = autoShipCompany ? autoShipCompany.data.name.split(' ').join('_') : null;
    //console.log('this is my autoShipCompnay', autoShipCompany);

    const companyListProps = {
      options: companies ? companies[0].clinics : '',
      getOptionLabel: (option) => option.company,
    };

    return (
      <div className={classes.logoHeader}>
        <div className={`logo-strip ${classes.soltaBackground} ${classes.headerBar}`}>
          <div className={classes.root}>
            <Grid container spacing={2} alignitems='center'>
              <Grid item xs={3}>
                {companies ? (
                  <Paper component='form' className={classes.searchForm} onSubmit={this.searchForClinic}>
                    <Autocomplete
                      {...companyListProps}
                      id='searchCompany'
                      clearOnEscape
                      name='searchCompany'
                      className={classes.autoFillSearchForm}
                      onChange={(event, newValue) => {
                        this.onCompanyUserChange(newValue);
                      }}
                      required
                      renderInput={(params) => <TextField {...params} label={t('header.search')} />}
                    />
                    <IconButton type='submit' onClick={this.searchForClinic}>
                      <SearchIcon className={classes.soltaColorFill} />
                    </IconButton>
                  </Paper>
                ) : null}
              </Grid>
              <Grid item xs={1}>
                <IconButton onClick={this.goHome}>
                  <HomeIcon className={classes.whiteText} style={{ fontSize: 28 }} />
                </IconButton>
              </Grid>
              <Grid item xs={2}>
                <Typography variant='body2' className={classes.whiteText}>
                  {t('header.clinic')}
                </Typography>
                <Typography variant='h5' className={classes.whiteText}>
                  {autoShipCompany ? autoShipCompany.data.name : '-'}
                </Typography>
                {autoShipCompany ? (
                  <Typography variant='body1' className={classes.whiteText}>
                    BILL TO ID: {autoShipCompany.data.billingID}
                  </Typography>
                ) : null}
              </Grid>
              <Grid item xs={3}>
                <Typography variant='body2' className={classes.whiteText}>
                  {t('header.clinicAddress')}
                </Typography>
                <Typography variant='body1' className={classes.whiteText}>
                  {autoShipCompany ? autoShipCompany.data.location.streetAddress : '-'} <br />
                  {autoShipCompany ? autoShipCompany.data.location.city + ', ' + autoShipCompany.data.location.state : null}
                </Typography>
              </Grid>
              <Grid item xs={3} align='right'>
                <Grid item xs container spacing={0} alignItems='center'>
                  <Grid item xs={7} align='right'>
                    {autoShipCompany ? (
                      <Tooltip title={t('header.saleSheet')} arial-label={t('header.saleSheet')}>
                        <IconButton onClick={() => this.createSalesSheetPdf({ fileName: `${clinicNameFileSafe}_autoship_promo.pdf`, autoShipCompany: autoShipCompany })}>
                          <PictureAsPdfIcon className={classes.whiteText} style={{ fontSize: 28 }} />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                  </Grid>
                  <Grid item xs={5} algin='right'>
                    <Typography variant='h4' className={classes.whiteText}>
                      {t('header.order')}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  //console.log('this is my state', state);
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
    companies: state.firestore.ordered.companyList,
    autoShipCompany: state.autoShip.autoShipCompany,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadAutoShipCompany: ({ clinicID, userID }) => dispatch(loadAutoShipCompany({ clinicID, userID })),
    exitAutoShipApp: () => dispatch(exitAutoShipApp()),
    clearAutoShipApp: () => dispatch(clearAutoShipApp()),
    clearAutoShipCompany: () => dispatch(clearAutoShipCompany()),
  };
};

export default compose(
  withStyles(styles),
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => {
    if (props.profile) {
      if (props.profile.role === ROLES.SUPERADMIN) {
        return [{ collection: 'lists', doc: 'companyList', storeAs: 'companyList' }];
      } else {
        return [{ collection: 'lists', doc: props.auth.uid, storeAs: 'companyList' }];
      }
    } else {
      return [];
    }
  })
)(Header);
